/* ============================================================
   REGINA – Produkt-Cross-Sell
   assets/section-product-cross-sell.js
   ------------------------------------------------------------
   Lädt Shopifys native Produktempfehlungen nach (offizielles
   Muster: Section per URL fetchen, Inhalt übernehmen). Bleibt
   unsichtbar, falls keine Empfehlungen existieren (z.B. sehr
   kleiner Katalog) – zeigt lieber nichts als eine leere Section.
   ============================================================ */
(function () {
  document.querySelectorAll('[data-cross-sell]').forEach(function (grid) {
    var section = grid.closest('[data-cross-sell-section]');
    var url = grid.dataset.url;
    if (!url) return;

    // Bereits serverseitig befüllt? Dann nur einblenden.
    if (grid.children.length > 0) {
      if (section) section.style.display = '';
      return;
    }

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cross-sell]');
        if (fresh && fresh.children.length > 0) {
          grid.innerHTML = fresh.innerHTML;
          if (section) section.style.display = '';
        }
        // keine Empfehlungen -> Section bleibt ausgeblendet (kein leerer Block sichtbar)
      })
      .catch(function () {
        // Fehler beim Nachladen -> Section bleibt schlicht ausgeblendet
      });
  });
})();
